import { QuestionBase } from './question-base';
import { Subscription, Observable, of } from 'rxjs';

/*
Sample:

new DatetimeQuestion({
  key: 'testDate',
  label: 'nouns.date',
  editable: true,
  time: [23, 59, 29, 999],
  value: new Date(),
  validators: { 'required': true, 'minDate': new Date() },
  order: -1
});

*/
export class DatetimeQuestion extends QuestionBase<Date> {
  controlType = 'datetime';
  // TODO USE THIS PROPERTIES
  locale: string;
  mode: string;
  enableTime: boolean;
  inline: boolean;
  _timezone: any;
  _maxDate: any;
  _minDate: any;
  defaultHour: number;
  defaultMinute: number;
  defaultSeconds: number;

  minDateSubscription: Subscription;
  maxDateSubscription: Subscription;
  disableDatesSubscription: Subscription;
  timezoneSubscription: Subscription;
  // TODO DELETE THIS PROPERTY
  options: any;

  constructor(options: any = {}) {
    super({ ...options, designSystem: true });
    this.mode = options.mode;
    this.inline = options.inline;
    this.enableTime = options.enableTime;
    this.timezone = options.timezone;
    this.maxDate = options.maxDate;
    this.minDate = options.minDate;
    this.disableDates = options._disableDates;
    this.locale = options.locale || localStorage.getItem('backofficelanguage') || navigator.language;
    this.defaultHour = options.defaultHour || 0;
    this.defaultMinute = options.defaultMinute || 0;
    this.defaultSeconds = options.defaultSeconds || 0;
  }

  onDeleteQuestion() {
    super.onDeleteQuestion();
    if (this.timezoneSubscription) {
      this.timezoneSubscription.unsubscribe();
    }
    if (this.disableDatesSubscription) {
      this.disableDatesSubscription.unsubscribe();
    }
    if (this.minDateSubscription) {
      this.minDateSubscription.unsubscribe();
    }
    if (this.maxDateSubscription) {
      this.maxDateSubscription.unsubscribe();
    }
  }

  set timezone(timezone) {
    if (timezone) {
      const timezoneObservable = timezone instanceof Observable ? timezone : of(timezone);
      this.timezoneSubscription = timezoneObservable.subscribe((timezone) => {
        this._timezone = timezone;
      });
    }
  }

  get timezone() {
    return this._timezone;
  }

  set minDate(minDate) {
    if (minDate) {
      const minDateObservable = minDate instanceof Observable ? minDate : of(minDate);
      this.minDateSubscription = minDateObservable.subscribe((date) => {
        setTimeout(() => {
          this._minDate = date;
        });
      });
    }
  }

  get minDate() {
    return this._minDate;
  }

  set maxDate(maxDate) {
    if (maxDate) {
      const maxDateObservable = maxDate instanceof Observable ? maxDate : of(maxDate);
      this.maxDateSubscription = maxDateObservable.subscribe((date) => {
        setTimeout(() => {
          this._maxDate = date;
        });
      });
    }
  }

  get maxDate() {
    return this._maxDate;
  }

  set disableDates(disableDates) {
    if (disableDates) {
      const disableDatesObservable = disableDates instanceof Observable ? disableDates : of(disableDates);
      this.disableDatesSubscription = disableDatesObservable.subscribe((dates) => {
        this._disableDates = dates;
      });
    }
  }

  get disableDates() {
    return this._disableDates;
  }
}
